import React from "react";
import "./TimelineComponent.css";
import { FaGraduationCap, FaBriefcase, FaProjectDiagram, FaStar } from "react-icons/fa";
import { useTranslation } from "../../i18n";
import { renderBrandText } from "../../utils/brandText";

// Datos de la línea de tiempo
const timelineCopy = {
  es: {
    title: "Mi trayectoria a lo largo de los años",
    items: [
      { year: "2022", title: "Graduado en Ingeniería Informática", description: "Finalicé mis estudios universitarios de Grado.", icon: <FaGraduationCap /> },
      { year: "2022", title: "Prácticas Universitarias", description: "Comencé mis primeras prácticas en una empresa de tecnología.", icon: <FaBriefcase /> },
      { year: "2022", title: "Primera Empresa", description: "Obtuve mi primer empleo en la industria tecnológica.", icon: <FaBriefcase /> },
      { year: "2023", title: "Desarrollo ChefMate", description: "Creé ChefMate, una plataforma innovadora para restaurantes.", icon: <FaProjectDiagram /> },
      { year: "2024", title: "Graduado Máster en IA", description: "Finalicé mi Máster en Inteligencia Artificial.", icon: <FaGraduationCap /> },
      { year: "2024", title: "Ascenso a QA Manager", description: "Conseguí un puesto como QA Manager en una empresa.", icon: <FaBriefcase /> },
      { year: "2024", title: "Desarrollo TestLab", description: "Desarrollé TestLab, una plataforma para aprender testing desde el móvil.", icon: <FaProjectDiagram /> },
      { year: "2025", title: "Nace TheQAHub", description: "Fundé TheQAHub como una plataforma educativa para enseñar QA y compartir conocimiento práctico con la comunidad.", icon: <FaStar /> },
      { year: "2025", title: "Nace TheQAHub Academy", description: "Lancé TheQAHub Academy como el primer paso de una academia enfocada en enseñar QA de forma clara, práctica y accesible.", icon: <FaStar /> },
      { year: "2026", title: "Nueva academia con diseño renovado", description: "Presentamos la nueva TheQAHub Academy con una identidad renovada, una experiencia más sólida y una propuesta formativa pensada para crecer.", icon: <FaStar /> },
    ],
  },
  en: {
    title: "My journey over the years",
    items: [
      { year: "2022", title: "Degree in Computer Engineering", description: "I completed my university degree studies.", icon: <FaGraduationCap /> },
      { year: "2022", title: "University Internship", description: "I started my first internship at a technology company.", icon: <FaBriefcase /> },
      { year: "2022", title: "First Company", description: "I got my first job in the technology industry.", icon: <FaBriefcase /> },
      { year: "2023", title: "ChefMate Development", description: "I created ChefMate, an innovative platform for restaurants.", icon: <FaProjectDiagram /> },
      { year: "2024", title: "Master's Degree in AI", description: "I completed my Master's Degree in Artificial Intelligence.", icon: <FaGraduationCap /> },
      { year: "2024", title: "Promotion to QA Manager", description: "I earned a QA Manager role at a company.", icon: <FaBriefcase /> },
      { year: "2024", title: "TestLab Development", description: "I developed TestLab, a mobile-first platform for learning testing.", icon: <FaProjectDiagram /> },
      { year: "2025", title: "TheQAHub Is Born", description: "I founded TheQAHub as an educational platform to teach QA and share practical knowledge with the community.", icon: <FaStar /> },
      { year: "2025", title: "TheQAHub Academy Is Born", description: "I launched TheQAHub Academy as the first step toward a QA academy built to teach in a clear, practical, and accessible way.", icon: <FaStar /> },
      { year: "2026", title: "New Academy with a refreshed design", description: "We introduced the new TheQAHub Academy with a renewed identity, a stronger experience, and a learning platform designed to scale.", icon: <FaStar /> },
    ],
  },
  de: {
    title: "Mein Werdegang im Laufe der Jahre",
    items: [
      { year: "2022", title: "Abschluss in Informatik", description: "Ich habe mein Universitätsstudium abgeschlossen.", icon: <FaGraduationCap /> },
      { year: "2022", title: "Universitätspraktikum", description: "Ich habe mein erstes Praktikum in einem Technologieunternehmen begonnen.", icon: <FaBriefcase /> },
      { year: "2022", title: "Erstes Unternehmen", description: "Ich bekam meine erste Stelle in der Technologiebranche.", icon: <FaBriefcase /> },
      { year: "2023", title: "Entwicklung von ChefMate", description: "Ich habe ChefMate entwickelt, eine innovative Plattform für Restaurants.", icon: <FaProjectDiagram /> },
      { year: "2024", title: "Masterabschluss in KI", description: "Ich habe meinen Master in Künstlicher Intelligenz abgeschlossen.", icon: <FaGraduationCap /> },
      { year: "2024", title: "Beförderung zum QA Manager", description: "Ich habe eine Position als QA Manager in einem Unternehmen erreicht.", icon: <FaBriefcase /> },
      { year: "2024", title: "Entwicklung von TestLab", description: "Ich entwickelte TestLab, eine mobile Plattform zum Lernen von Testing.", icon: <FaProjectDiagram /> },
      { year: "2025", title: "TheQAHub entsteht", description: "Ich gründete TheQAHub als Bildungsplattform, um QA zu vermitteln und praxisnahes Wissen mit der Community zu teilen.", icon: <FaStar /> },
      { year: "2025", title: "TheQAHub Academy entsteht", description: "Ich startete die TheQAHub Academy als ersten Schritt zu einer QA-Akademie, die klar, praxisnah und zugänglich aufgebaut ist.", icon: <FaStar /> },
      { year: "2026", title: "Neue Academy mit modernisiertem Design", description: "Wir präsentierten die neue TheQAHub Academy mit erneuerter Identität, stärkerem Erlebnis und einer Lernplattform, die auf Wachstum ausgelegt ist.", icon: <FaStar /> },
    ],
  },
};

const TimelineComponent = () => {
  const { language } = useTranslation();
  const timeline = timelineCopy[language] || timelineCopy.es;
  const timelineKicker = {
    es: "Trayectoria",
    en: "Journey",
    de: "Werdegang",
  };

  return (
    <div className="timeline-container">
      <div className="timeline-heading">
        <span className="about-section-kicker">{timelineKicker[language] || timelineKicker.es}</span>
        <h2 className="timeline-title section-title-academy">{timeline.title}</h2>
      </div>
      <div className="timeline">
        {timeline.items.map((item, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}>
            <div className="timeline-icon">{item.icon}</div>
            <div className="timeline-content">
              <h3>{item.year} - {renderBrandText(item.title)}</h3>
              <p>{renderBrandText(item.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimelineComponent;
